import React from 'react';
import { CalendarDropdownPrimitives, type Frequency } from './CalendarDropdownPrimitives';
import { useCalendarDropdown } from './useCalendarDropdown';
import type { AsOfDateSetting } from 'venn-utils';

export const CalendarDropdown = ({
  value,
  lastUpdated,
  start,
  end,
  frequency,
  disabled,
  onChange,
  triggerSize,
}: {
  value: AsOfDateSetting;
  lastUpdated: Date | undefined;
  start: Date | undefined;
  end: Date | undefined;
  frequency: Frequency;
  disabled: boolean;
  onChange: (value: AsOfDateSetting) => void;
  triggerSize: 'small' | 'normal';
}) => {
  const { selectedDate, onValueChange, begin, ending, formattedDisplayDate, lastUpdatedValue } = useCalendarDropdown({
    value,
    lastUpdated,
    currentDate: undefined,
    start,
    end,
    onChange,
  });
  return (
    <CalendarDropdownPrimitives.Root onValueChange={onValueChange} disabled={disabled} selectedDate={selectedDate}>
      <CalendarDropdownPrimitives.Trigger formattedDisplayDate={formattedDisplayDate} size={triggerSize} />
      <CalendarDropdownPrimitives.ContentRoot variant="accordion">
        <CalendarDropdownPrimitives.AccordionDateContent
          value={value}
          end={end}
          frequency={frequency}
          begin={begin}
          ending={ending}
          lastUpdatedValue={lastUpdatedValue}
        />
      </CalendarDropdownPrimitives.ContentRoot>
    </CalendarDropdownPrimitives.Root>
  );
};
